import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export const Proof = () => {
  return <section className="py-16 md:py-24 px-6 bg-terracotta/10" data-id="element-79">
      <div className="max-w-3xl mx-auto text-center" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-terracotta/20 relative" data-id="element-81">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-terracotta text-white p-3 rounded-full shadow-md" data-id="element-82">
            <Quote size={24} data-id="element-83" />
          </div>
          <p className="text-xl md:text-2xl font-sans text-charcoal leading-relaxed mt-4" data-id="element-84">
            "En los primeros 7 días, la mayoría de los padres reportan que los
            despertares nocturnos se reducen a la mitad. Al llegar al día 14, el
            bebé es capaz de dormir un bloque consolidado de 6 a 7 horas,
            transformando por completo el clima emocional de la casa."
          </p>
        </motion.div>
      </div>
    </section>;
};